import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReachSelectService {

  private reachSource = new BehaviorSubject<string>("");
  currentReach = this.reachSource.asObservable();

  constructor() {}

  selectReach(ReachNumber: string) {
    this.reachSource.next(ReachNumber)
  }

}
